module.exports = __webpack_public_path__ + "static/1.2_Heart_Icon-cce2ffff69eaafc719f9c86a1cdf5829.svg";